import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9bdc26"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { ref, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { HelpMenuItem } from "@/types/help";
import { useStore } from "vuex";
// 判断是否为新手引导状态

export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenusHelp',
  setup(__props) {

const driverState = computed(() => !!store.getters.getDriverState);
const router = useRouter();
const route = useRoute();
const helpMenus = reactive<HelpMenuItem[]>([
  {
    id: 1,
    path: "/help/faq",
    lang: "user_center.faq",
  },
  {
    id: 4,
    path: "/help/video",
    lang: "user_center.video",
  },
  {
    id: 2,
    path: "/help/books",
    lang: "header.user_tutorial",
  },
  {
    id: 3,
    path: "/help/contactUs",
    lang: "user_center.contact_us",
  },
]);
const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const helpMenusShow = computed(() => {
  let arr: HelpMenuItem[] = [];
  helpMenus.map((item: HelpMenuItem) => {
    // 手机版移除用户手册
    if (isMobile.value && item.id !== 2) {
      arr.push(item);
    }
    // PC端显示全部
    if (!isMobile.value) {
      arr.push(item);
    }
  });
  return arr;
});
const activeMenuPath = ref("");
const initActiveMenuName = () => {
  const menuItem = helpMenus.find((i) => route.path === i.path);
  activeMenuPath.value = menuItem ? menuItem.path : "";
};
initActiveMenuName();
const changeRouter = (item: HelpMenuItem): void => {
  if (driverState.value) {
    return;
  }
  router.push(item.path).then((res) => {
    initActiveMenuName();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass({ mobileSize: _unref(isMobile) })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(helpMenusShow), (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        onClick: ($event: any) => (changeRouter(item)),
        class: _normalizeClass([
        { active: item.path.startsWith(activeMenuPath.value) },
        'menu' + item.id,
      ]),
        key: index
      }, _toDisplayString(_ctx.$t(item.lang)), 11, _hoisted_1))
    }), 128))
  ], 2))
}
}

})